import Button from "@mui/material/Button";

// CSS
import "../style/about.css";

// Pictures
import tvc_logo from "../photos/tvc_logo.png";
import about_img from "../photos/about.jpg";
export default function About() {
  return (
    <div className="About">
      <div className="about_Text">
        <h1> More than a camera store since 2016</h1>

        <span>
          <p>
            <br />
            {"   "} <i>The Vintage Collective</i> is a shop celebrating
            photography, art, travel and lifestyle. Based in Metro Manila, we
            provide you, the growing community of artists, lost souls and
            photographers your tools to capture memories, tell stories, and
            express your creativity. Making your memories last forever through
            the art of photography and almost everything related. This is
            something we do because we have a passion for it. Let's keep the
            collective alive!
            <br />
            <br />
            All the products posted are thoroughly inspected and carefully
            described. We also develop film and repair any kinds of cameras.
            <br />
            <br />
            If you have any questions about anything please don't hesitate to
            reach us out.
          </p>
        </span>
      </div>
      <div className="about_Img">
        <img src={tvc_logo} alt="The Vintage Collective" />
      </div>
    </div>
  );
}
